import { render, staticRenderFns } from "./RankingSearch.vue?vue&type=template&id=21abddb8&scoped=true"
import script from "./RankingSearch.vue?vue&type=script&lang=js"
export * from "./RankingSearch.vue?vue&type=script&lang=js"
import style0 from "./RankingSearch.vue?vue&type=style&index=0&id=21abddb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abddb8",
  null
  
)

export default component.exports